import { useState } from "react";
import { HistoryBox } from "../../styles/BoxingStyles";
import {DText, FlexCenter, FlexStart, GlobalLoadingWrapper} from "../../styles/CommonStyles";
import { OrdersTab } from "../../styles/OrdersStyle";
import Text from "../../utils/Text";
import CurrentOrders from "./CurrentOrders";
import History from "./History";
import {PuffLoader} from "react-spinners";
import {useMainContext} from "../../contexts/main";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {TABLET_SIZE} from "../../constants/common";
import RCurrentOrders from "../responsive/RCurrentOrders";
import {HOME} from "../../constants/urls";
import RHistory from "../responsive/RHistory";


const OrdersHistory = () => {

    const {_loading, profile: {token}} = useMainContext()
    const { width } = useWindowSize()

    const [activeTab, setActiveTab] = useState(0)

    const onTabClicked = (idx) => {
        if (idx !== activeTab) {
            setActiveTab(idx)
        }
    }

    const goToRegister = () => {
        window.location.href = HOME + "user/register-signin"
    }

    if (!token) {
        return (
            <HistoryBox>
                <FlexCenter height="300px" style={{ cursor: "pointer" }} onClick={() => goToRegister()}>
                    <DText fontSize="1rem" color="#0d60a1"><Text tid="signin" />/</DText>
                    <DText fontSize="1rem" color="#0d60a1"><Text tid="register" /></DText>
                </FlexCenter>
            </HistoryBox>
        )
    }

    return (
        <HistoryBox>
            <FlexStart>
                {tabs.map((tab, idx) => (
                    <OrdersTab
                        active={activeTab === idx}
                        onClick={() => onTabClicked(idx)}
                    >
                        <DText><Text tid={tab} /></DText>
                    </OrdersTab>
                ))}
            </FlexStart>
            {activeTab === 0 && (
                width > TABLET_SIZE ?
                    <CurrentOrders hasFilters={true} />
                    :
                    <RCurrentOrders />
                )}
            {activeTab === 1 && (
                width > TABLET_SIZE ?
                    <History />
                    :
                    <RHistory />
                )}
            {_loading &&
                <GlobalLoadingWrapper>
                    <PuffLoader size={24} color="#0d60a1" />
                </GlobalLoadingWrapper>
            }
        </HistoryBox>
    )
}

const tabs = ["current-orders", "orders-history"]

export default OrdersHistory;
